function normalizedCalculationPrices(result = {}) {
  const number = (value) => (value === null || value === undefined || value === "" ? null : Number(value));
  return (result.available_price_series || result.price_series || []).map((point) => ({
    date: point.date ?? point.trade_date,
    value: Number(point.close),
    open: number(point.open),  // 日 K 线用（不复权）；场外基金和旧响应没有，是 null
    high: number(point.high),
    low: number(point.low),
  })).filter((point) => point.date && Number.isFinite(point.value) && point.value > 0);
}

export function resultPriceSeries(result = {}) {
  return normalizedCalculationPrices(result);
}

export function calculationBenchmarkSeries(result = {}) {
  const displaySeries = result.benchmark_display_series;
  const source = Array.isArray(displaySeries) && displaySeries.length > 0
    ? displaySeries
    : (result.benchmark_series || []);
  return source.map((point) => ({
    ...point,
    value: Number(point.close ?? point.growth_multiple),
  })).filter((point) => point.date && Number.isFinite(point.value));
}
